import { Subcontractor } from "../models/subcontractor";
import BaseService from "./_base.service";

const endpoint = "subcontractors";

const SubcontractorService = {
  ...BaseService<Subcontractor>({ endpoint }),
};

export default SubcontractorService;
